import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel';

(function($){

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  var initializeBlock = function( $block ) {


    var $lgPaging = $block.find('.listGalleryPagingInfo')
    var $listGalleryCarousel = $block.find('.list-gallery-carousel')
    
    $listGalleryCarousel.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      if(!slick.$dots){
        return;
      }
      var i = (currentSlide ? currentSlide : 0) + 1;
      $lgPaging.text(i + ' of ' + (slick.$dots[0].children.length));
    });
    
    $listGalleryCarousel.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: true,
      arrows: true,
      prevArrow: '.l-carousel-arrow-prev',
      nextArrow: '.l-carousel-arrow-next',
    })


  }

  // Initialize each block on page load (front end).
  $(document).ready(function(){
      $('.list-and-gallery-block').each(function(){
          initializeBlock( $(this) );
      });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
      window.acf.addAction( 'render_block_preview/type=list-image-carousel-section', initializeBlock );
  }

})(jQuery);
